import React from "react";
import "./Landing.css";
import logo from "../../assets/logo.png";
import Login from "../Login/Login";
import { useNavigate } from "react-router-dom";

function Landing() {
	const history = useNavigate();

	return (
		<div className="landing">
			<div
				className="landing__bg"
				style={{
					backgroundImage: `url("https://assets.nflxext.com/ffe/siteui/vlv3/5e48e7b6-350d-48d9-96d6-de8ca173c89f/083b0034-e11a-432d-9a74-0b6b0eec0e39/EG-en-20221219-popsignuptwoweeks-perspective_alpha_website_large.jpg")`,
				}}
			/>
			<header className="landing__header">
				<img
					className="landing__logo"
					src={logo}
					alt="RokFlix"
					onClick={() => history("/")}
				/>
			</header>
			<div className="landing__body">
				<Login />
			</div>
		</div>
	);
}

export default Landing;
